import {
    Box,
    Typography,
    TextField,
    FormControl,
    InputAdornment,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    Divider,
    Dialog,
    DialogContent,
    IconButton,
    Tooltip,
} from "@mui/material";

import React from "react";
import { styled } from "@mui/material/styles";
import { CancelOutlined } from "@mui/icons-material";
import { useState, useEffect, useRef } from "react";
import upload from "../../../assets/Project_Images/Icons/upload.png";
import gallery from "../../../assets/Project_Images/Icons/gallery.png";
import info from '../../../assets/Project_Images/Icons/info.png'

import { useFormik } from "formik";
import * as Yup from "yup";
import {
    ApiDeleteAccount,
    ApiGetClientDbName,
    ApiGetClientEntities,
    ApiGetClients,
    ApiGetDigisigner,
    ApiGetShopperDetails,
    ApiGetSignedStatement,
    ApiGetVenueList,
    ApiUpdateFinancialDetails,
    ApiUpdateProfiledetails,
    ApiuploadDocuments,
} from "../../../apiService/Core/Apicall.tsx";
// import { ApisendApplication } from "../../../apiService/Core/Apicall.tsx";
import { Link, useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
// import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import Loading from "../../Loader/Loading.tsx";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    borderWidth: "5px",
    width: 22,
    height: 22,
    borderColor: "green",
    boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    // backgroundColor: '#f5f8fa',
    backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
        outline: "2px auto #ADB792",
        outlineOffset: 2,
    },
}));
const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#ADB792",
    backgroundImage:
        "linear-gradient(180deg,hsla(0,100%,0%,.1),hsla(0,100%,0%,0))",
    "&::before": {
        display: "block",
        width: 22,
        height: 22,
        backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
        content: '""',
    },
});

// Inspired by blueprintjs
function BpRadio(props: any) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            {...props}
        />
    );
}

interface FormValues {
    firstname: string;
    lastname: string;
    email: string;
    contactNo: string;
    address: string;
    dob: Dayjs;
    gender: string;
    profile_pic: string;
    driving_licence: string;
    latitude: string;
    longitude: string;
    workForAldi: boolean | string;
    workForBlooms: boolean | string;
    workForHotelpub: boolean | string;
    buyAlcohol: boolean | string;
    hotelPubName: string;
    // shoppperDetail: string;
    isShopperCanVisitSmokingArea: boolean | string;
    isShopperCanDoGambling: boolean | string;
    isShopperRelativeWorkForYochi:boolean | string;
    isShopperRelativeWorkForJbHifi:boolean | string;
    bankName: string;
    bic: string;
    accountNo: string;
    abn: string;
    ABNNumber: string;
    statement_by_supplier: string
    country: string,
    countryCode: string,
    state: string,
    city: string,
    postalCode: Number,

}

interface VenueSelection {
    clientId: string;
    selectedClientId: string;
    clientEntityId: string;
    venueId: string;
    clientsList: any[];
    clientEntityList: any[];
    venueList: any[];
}

function Profile() {
    // const dispatch = useDispatch();
    const loading = useSelector((state: any) => state.loader.isLoading);

    const navigate = useNavigate();
    const autocompleteRef = useRef<any>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const [showerror, setshowerror] = useState<boolean>(false);
    const [isdeletempty, setisdeletempty] = useState<boolean>(false);
    const [isdeleteopen, setisdeleteopen] = useState<boolean>(false);
    const [deletemsg, setdeletemsg] = useState<string>('');
    const [venueSelections, setVenueSelections] = useState<VenueSelection[]>([
        {
            clientId: "",
            selectedClientId: "",
            clientEntityId: "",
            venueId: "",
            clientsList: [],
            clientEntityList: [],
            venueList: [],
        },
    ]);
    const [allSelectedVenueIds, setAllSelectedVenueIds] = useState<string>("");
    const [Clientlist, setClientlist] = useState<any[]>([]);

    const emailId = localStorage.getItem("emailId");
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    const [userDetails, setuserdetails] = useState<any>([]);
    const [isCreate, setisCreate] = useState<boolean>(userDetails?.shopperOtherDetail?.statementOfsupplier ?? false);
    const [fulladdress, setfulladdress] = useState<any>()
    const [streetNumber, setstreetNumber] = useState<any>()
    const [route, setroute] = useState<any>()
    const documentId = localStorage.getItem('documentId') || ''
    const needsEditProfile = localStorage.getItem("nep") == "true" || false;

    const getprofile = async () => {
        try {
            const response = await ApiGetShopperDetails(`/${userData.userId}`)
            setuserdetails(response.data)
        } catch (error) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }
    useEffect(() => {

        if (!needsEditProfile) {
            getprofile();
        }
    }, [])

    // Restore form values when component mounts
    useEffect(() => {
        const savedForm = localStorage.getItem("applyOnlineForm");
        if (savedForm) {
            setfulladdress(localStorage.getItem('fa') || '')
            const parsedValues = JSON.parse(savedForm);
            Object.keys(parsedValues).forEach((key) => {
                formik.setFieldValue(key, parsedValues[key]);
            });
        }
    }, [fulladdress]);
    useEffect(() => {
        !localStorage.getItem("i-x-s") && setfulladdress(`${userDetails?.address} ${userDetails?.city} ${userDetails?.state} ${userDetails?.postalCode}, ${userDetails?.country}`)
    }, [userDetails])

    const initialValues: FormValues =
    {
        firstname: userDetails?.firstName ?? "",
        lastname: userDetails?.lastName ?? "",
        email: emailId ? emailId : userData?.emailId,
        contactNo: userDetails?.contactNo ?? "",
        address: userDetails?.address ?? "",
        dob: userDetails?.dob ?? null as Dayjs | null,
        gender: userDetails?.gender ?? "",
        profile_pic: userDetails?.profilePicUrl ?? "",
        driving_licence: userDetails?.driving_licence ?? "",
        latitude: userDetails?.latitude ?? "",
        longitude: userDetails?.longitude ?? "",
        workForAldi: userDetails?.workForAldi ?? "",
        workForBlooms: userDetails?.workForBlooms ?? "",
        workForHotelpub: String(userDetails?.workForHotelpub) ?? "",
        buyAlcohol: userDetails?.shopperOtherDetail?.isShopperBuyAlcohol ?? "",
        // shoppperDetail: userDetails?.shopperOtherDetail?.shoppperDetail ?? "",
        hotelPubName: userDetails?.hotelPubName ?? "",
        isShopperCanVisitSmokingArea: userDetails?.shopperOtherDetail?.isShopperCanVisitSmokingArea ?? "",
        isShopperCanDoGambling: userDetails?.shopperOtherDetail?.isShopperCanDoGambling ?? "",
        isShopperRelativeWorkForYochi: userDetails?.shopperOtherDetail?.isShopperRelativeWorkForYochi ?? "",
        isShopperRelativeWorkForJbHifi: userDetails?.shopperOtherDetail?.isShopperRelativeWorkForJbHifi ?? "",
        bankName: userDetails?.bankName ?? '',
        bic: userDetails?.bic ?? '',
        accountNo: userDetails?.accountNo ?? '',
        abn: ((userDetails?.shopperOtherDetail?.isProceedWithABN) === true ? "isProceedWithABN" : 'isProceedWithStatementOfSupplier'),
        ABNNumber: userDetails?.shopperOtherDetail?.ABNNumber ?? '',
        statement_by_supplier: userDetails?.shopperOtherDetail?.statementOfsupplier ?? '',
        country: userDetails?.country,
        countryCode: userDetails?.countryCode ?? '+61',
        state: userDetails?.state,
        city: userDetails?.city,
        postalCode: userDetails?.postalCode
    };


    const validateABN = (abn: string | undefined) => {
        if (!abn) return false;

        // Remove spaces
        abn = abn.replace(/\s/g, '');

        // Must be 11 digits
        if (!/^\d{11}$/.test(abn)) return false;

        // Convert to array of numbers
        let digits = abn.split('').map(Number);

        // Subtract 1 from the first digit
        digits[0] -= 1;

        // Weighting factors
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

        // Calculate sum
        const sum = digits.reduce((acc, digit, index) => acc + digit * weights[index], 0);

        // Valid if sum is a multiple of 89
        return sum % 89 === 0;
    };

    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };
    const validationSchema = Yup.object({
        firstname: Yup.string().required("firstname is required"),
        lastname: Yup.string().required("lastname is required"),
        contactNo: Yup.string().required("contactNo is required"),
        profile_pic: Yup.string().required("profile image is required"),
        driving_licence: Yup.string().required("driving licence is required"),
        address: Yup.string().required("address is required"),
        dob: Yup.string().required("dob is required"),
        gender: Yup.string().required("gender is required"),
        workForAldi: Yup.string().required("This field is required"),
        workForBlooms: Yup.string().required("This field is required"),
        workForHotelpub: Yup.string().required("This field is required"),
        buyAlcohol: Yup.string().required("This field is required"),
        bankName: Yup.string().required('bankname is requied'),
        bic: Yup.string().required('bsb is requied'),
        accountNo: Yup.string().required('account number is requied'),
        abn: Yup.string().required('abn is requied'),
        ABNNumber: Yup.string().when('abn', {
            is: (val) => val === 'isProceedWithABN',
            then: (schema) =>
                schema
                    .required('ABN is required')
                    .test('is-valid-abn', 'Invalid ABN', (value) => validateABN(value)),
            otherwise: (schema) => schema.notRequired(),
        }),
        // shoppperDetail: Yup.string()
        //     .test(
        //         "min-words",
        //         "Minimum 150 words required",
        //         (value) =>
        //             (value?.trim().split(/\s+/).filter(Boolean).length ?? 0) >= 150
        //     )
        //     .test(
        //         "max-words",
        //         "Maximum 500 words allowed",
        //         (value) =>
        //             (value?.trim().split(/\s+/).filter(Boolean).length ?? 0) <= 500
        //     )
        //     .required("shopperDetail is required"),
        isShopperCanVisitSmokingArea: Yup.string().required(
            "This field is required"
        ),
        isShopperCanDoGambling: Yup.string().required("This field is required"),
        isShopperRelativeWorkForJbHifi: Yup.string().required("This field is required"),
        isShopperRelativeWorkForYochi: Yup.string().required("This field is required"),
    });
    const formStyles = {
        container: {
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#fff",
        },
        section: {
            marginBottom: "30px",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: "20px",
        },
        sectionTitle: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
        },
        sectionNumber: {
            marginRight: "8px",
        },
        sectionDescription: {
            fontSize: "14px",
            color: "#666",
            marginBottom: "15px",
        },
        formRow: {
            display: "flex",
            flexWrap: "wrap",
            margin: "0 -10px",
            marginBottom: "15px",
        },
        formColumn: {
            flex: "1 0 calc(50% - 20px)",
            margin: "0 10px",
            minWidth: "250px",
        },
        formColumnFull: {
            flex: "1 0 calc(100% - 20px)",
            margin: "0 10px",
        },
        formColumnThird: {
            flex: "1 0 calc(33.333% - 20px)",
            margin: "0 10px",
            minWidth: "200px",
        },
        formColumnQuarter: {
            flex: "1 0 calc(25% - 20px)",
            margin: "0 10px",
            minWidth: "180px",
        },
        inputLabel: {
            display: "block",
            fontSize: "14px",
            marginBottom: "5px",
            color: "#333",
        },
        requiredStar: {
            color: "red",
            marginLeft: "2px",
        },
        textField: {
            width: "100%",
            padding: "8px 12px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
            boxSizing: "border-box",
        },
        radioGroup: {
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
        },
        radioLabel: {
            marginRight: "20px",
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
        },
        radioInput: {
            marginRight: "5px",
            width: "16px",
            height: "16px",
            accentColor: "#1976d2",
            cursor: "pointer",
        },
        uploadBox: {
            border: "1px dashed #ccc",
            borderRadius: "4px",
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "50%",
            position: "relative" as const,
        },
        uploadIcon: {
            fontSize: "24px",
            color: "#666",
            marginBottom: "8px",
        },
        uploadText: {
            fontSize: "14px",
            color: "#666",
        },
        textareaField: {
            width: "100%",
            padding: "8px 12px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
            minHeight: "100px",
            boxSizing: "border-box",
            resize: "vertical",
        },
        wordCount: {
            fontSize: "12px",
            color: "#666",
            textAlign: "right",
            marginTop: "5px",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "20px",
        },
        button: {
            padding: "10px 20px",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
        },
        otherDetailsContainer: {
            display: "flex",
            flexWrap: "wrap",
            gap: "15px",
            marginBottom: "20px",
        },
        otherDetailsItem: {
            flex: "1 0 200px",
            minWidth: "200px",
        },
        questionContainer: {
            marginBottom: "10px",
        },
        fileInput: {
            position: "absolute" as const,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
        },
        // Clean dropdown styles matching the image design
        dropdownContainer: {
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginBottom: "15px",
            flexWrap: "wrap",
        },
        dropdown: {
            width: "200px",
            height: "45px",
            padding: "0 15px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            color: "#6b7280",
            backgroundColor: "#ffffff",
            cursor: "pointer",
            outline: "none",
            appearance: "none",
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
            backgroundPosition: "right 12px center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "16px",
            transition: "border-color 0.15s ease-in-out",
        },
        dropdownFocus: {
            borderColor: "#3b82f6",
            boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
        },
        iconButton: {
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            transition: "all 0.2s ease",
        },
        addButton: {
            backgroundColor: "#10b981",
            color: "white",
            "&:hover": {
                backgroundColor: "#059669",
            },
        },
        removeButton: {
            backgroundColor: "#ef4444",
            color: "white",
            "&:hover": {
                backgroundColor: "#dc2626",
            },
        },
    };


    const onSubmit = async (values: FormValues) => {

        const addIfChanged = (key: string, transform: (val: any) => any = (v) => v, apiKeyName?: string) => {
            const value = values[key];
            if (value !== undefined && value !== initialValues[key]) {
                apiData[apiKeyName || key] = transform(value);
            }
        };
        const addIfChanged2 = (key: string, transform: (val: any) => any = (v) => v, apiKeyName?: string) => {
            const value = values[key];
            if (value !== undefined && value !== initialValues[key]) {
                apiData2[apiKeyName || key] = transform(value);
            }
        };
        const userId = userData.userId || 0;
         const isAddressChanged = values.address !== initialValues.address;

        const apiData: any = {
            userId,
            modifiedBy: userId,
            isFirstTimeUpdate: false,
            relativeVenueIds: allSelectedVenueIds,
            country: values.country,
            state: values.state,
            city: values.city,
            postalCode: values.postalCode,
            profilePicUrl: values.profile_pic
        };
        addIfChanged("driving_licence");
        addIfChanged("contactNo", (val) => {
            if (!val) return val;
            return val.startsWith(values.countryCode) ? val.slice(values.countryCode.length) : val;
        });
        addIfChanged("countryCode", (val) => val)
        addIfChanged("address", (val) => val);
        // addIfChanged("profilePicUrl", (val) => val);
        addIfChanged("latitude", (val) => Number(val) || 0);
        addIfChanged("longitude", (val) => Number(val) || 0);
        addIfChanged("workForAldi", (val) => val === "true");
        addIfChanged("workForBlooms", (val) => val === "true");
        addIfChanged("workForHotelpub", (val) => val === "true");
        addIfChanged("buyAlcohol", (val) => val === "true", "isShopperBuyAlcohol");
        addIfChanged("isShopperCanVisitSmokingArea", (val) => val === "true");
        addIfChanged("isShopperCanDoGambling", (val) => val === "true");
        addIfChanged("isShopperRelativeWorkForYochi", (val) => val === "true");
        addIfChanged("isShopperRelativeWorkForJbHifi", (val) => val === "true");

        if (values.workForHotelpub === "true" && values.hotelPubName !== initialValues.hotelPubName) {
            apiData.hotelPubName = values.hotelPubName;
        }

        const apiData2: any = {

            userId,
            modifiedBy: userId,

        }
        addIfChanged2("bankName");
        addIfChanged2("bic");
        addIfChanged2("accountNo");
        addIfChanged2("ABNNumber");
        addIfChanged2("statement_by_supplier", (val) => val, "statementOfsupplier");

        // Conditional logic for ABN radio buttons
        apiData2.isProceedWithStatementOfSupplier = values.abn === 'isProceedWithStatementOfSupplier';
        apiData2.isProceedWithABN = values.abn === 'isProceedWithABN';

        try {
            console.log("Street Number", streetNumber)
            console.log("Route", route)
            if (isAddressChanged && (!streetNumber || !route)) {
                formik.setFieldError('address', 'Please select a valid address');
                return;
            }
            const response = await ApiUpdateProfiledetails(apiData);
            const response2 = await ApiUpdateFinancialDetails(apiData2);
            if (response.status && response2.status) {
                toast.success(response.message);
                localStorage.removeItem('doumentId')
                localStorage.removeItem('nep')
                localStorage.removeItem("ng");
                localStorage.removeItem("i-x-s");
                localStorage.removeItem("i-x-s-u");
            } else {
                toast.success(response.message);
            }
        } catch (error) {
            console.error("API Error:", error);
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    };



    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        enableReinitialize: true,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: false,

    });
    // console.log("Updoaded statement", formik.values.statement_by_supplier)

    useEffect(() => {
        const loadAutocomplete = async () => {
            if (!window.google) {
                console.error("Google Maps API is not loaded.");
                return;
            }

            if (!inputRef.current) {
                console.error("Input reference is null.");
                return;
            }

            try {
                autocompleteRef.current = new window.google.maps.places.Autocomplete(
                    inputRef.current as HTMLInputElement,
                    {
                        types: ["geocode"],
                        componentRestrictions: { country: "AU" },
                    }
                );

                autocompleteRef.current.addListener("place_changed", async () => {
                    const place = await autocompleteRef.current.getPlace();
                    // console.log("Autocomplete place object:", place);

                    if (!place || !place.formatted_address) {
                        console.warn("No address found.");
                        return;
                    }
                    if (place.geometry?.location) {
                        formik.setFieldValue("latitude", place.geometry.location.lat());
                        formik.setFieldValue("longitude", place.geometry.location.lng());
                    }

                    let streetNumber = ''
                    let route = ''
                    let subpremise = ''
                    setfulladdress(place?.formatted_address)
                    place?.address_components?.forEach((component: any) => {
                        const types = component.types;
                        if (types.includes("country")) {
                            formik.setFieldValue("country", component.short_name); // e.g. "Australia"
                            // formik.setFieldValue("countryCode", component.short_name);// e.g. "AU"
                        }
                        if (types.includes("street_number")) {
                            streetNumber = component.long_name; // e.g. "221B"
                        }

                        if (types.includes("route")) {
                            route = component.long_name; // e.g. "Baker Street"
                        }
                        if (types.includes("subpremise")) {
                            subpremise = component.long_name; // e.g. "Baker Street"
                        }
                        if (types.includes("administrative_area_level_1")) {
                            formik.setFieldValue("state", component.short_name); // e.g. "New South Wales"
                        }
                        if (types.includes("locality")) {
                            formik.setFieldValue("city", component.long_name); // e.g. "Sydney"
                        }
                        if (types.includes("postal_code")) {
                            formik.setFieldValue("postalCode", component.long_name); // e.g. "2000"
                        }
                        formik.setFieldValue('address', subpremise + " " + streetNumber + " " + route)
                        setroute(route)
                        setstreetNumber(streetNumber)
                    });

                });
            } catch (error) {
                console.error("Error initializing autocomplete:", error);
            }
        };

        loadAutocomplete();
        handleCallGetClientDbName();
    }, []);

    const handleCallGetClientDbName = async () => {
        try {
            {
                const response = await ApiGetClientDbName();
                setClientlist(response.data);
            }
        } catch (error) {
            console.error("Error during API call:", error);
            // toast.error(`${error}`);
        }
    };


    const addVenueSelection = () => {
        setVenueSelections([
            ...venueSelections,
            {
                clientId: "",
                selectedClientId: "",
                clientEntityId: "",
                venueId: "",
                clientsList: [],
                clientEntityList: [],
                venueList: [],
            },
        ]);
    };

    const removeVenueSelection = (index: number) => {
        if (venueSelections.length > 1) {
            const updatedSelections = [...venueSelections];
            updatedSelections.splice(index, 1);
            setVenueSelections(updatedSelections);
        }
    };

    const handleClientDbChange = async (index: number, clientId: string) => {
        const updatedSelections = [...venueSelections];
        updatedSelections[index] = {
            ...updatedSelections[index],
            clientId,
            selectedClientId: "",
            clientEntityId: "",
            venueId: "",
            clientsList: [],
            clientEntityList: [],
            venueList: [],
        };

        if (clientId) {
            try {
                const data = `?clientGroup=${clientId}&status=active&offset=0&limit=100`;
                // Replace with your actual API call
                const response: any = await ApiGetClients(data);
                updatedSelections[index].clientsList = response.data || [];
            } catch (error) {
                console.error("Error during API call:", error);
            }
        }

        setVenueSelections(updatedSelections);
    };

    const handleClientChange = async (
        index: number,
        selectedClientId: string
    ) => {
        const updatedSelections = [...venueSelections];
        updatedSelections[index] = {
            ...updatedSelections[index],
            selectedClientId,
            clientEntityId: "",
            venueId: "",
            clientEntityList: [],
            venueList: [],
        };

        if (selectedClientId) {
            try {
                const data = `?clientId=${selectedClientId}&offset=0&limit=100`;
                // Replace with your actual API call
                const response: any = await ApiGetClientEntities(data);
                updatedSelections[index].clientEntityList = response.data || [];
            } catch (error) {
                console.error("Error during API call:", error);
            }
        }

        setVenueSelections(updatedSelections);
    };

    const handleBusinessChange = async (
        index: number,
        clientEntityId: string
    ) => {
        const updatedSelections = [...venueSelections];
        updatedSelections[index] = {
            ...updatedSelections[index],
            clientEntityId,
            venueId: "",
            venueList: [],
        };

        if (clientEntityId) {
            try {
                const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`;
                // Replace with your actual API call
                const res = await ApiGetVenueList(data);
                const venueOptions =
                    res?.data?.map((item: any) => ({
                        label: item.venueName,
                        value: item.venueId,
                    })) || [];
                updatedSelections[index].venueList = venueOptions;
            } catch (error) {
                console.error("Error fetching venues:", error);
            }
        }

        setVenueSelections(updatedSelections);
    };

    const handleVenueChange = (index: number, venueId: string) => {
        const updatedSelections = [...venueSelections];
        updatedSelections[index].venueId = venueId;
        setVenueSelections(updatedSelections);

        const selectedVenueIds = updatedSelections
            .map((selection) => selection.venueId)
            .filter((id) => id);

        setAllSelectedVenueIds(selectedVenueIds.join(","));
    };

    const fileupload = async (filePath: any, fileType: string) => {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const formData = new FormData();
        formData.append("userId", userData.userId);
        formData.append("fileType", fileType);
        formData.append("file", filePath);
        // console.log('file Type', fileType)
        // console.log("file Pathe", filePath)
        try {
            const response: any = await ApiuploadDocuments(formData);
            if (response.status) {
                // console.log(response)
                // console.log('Response of file tye', response.location)
                formik.setFieldValue(fileType, response.location);
            }
        } catch (error) {
            console.log(error)
        }

    };
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file && file.type.startsWith("image/")) {
            const imageUrl = URL.createObjectURL(file);
            fileupload(file, "profile_pic");
        } else {
            toast.success("Please upload a valid image file.");
        }
    };
    const handleFileChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file2 = event.target.files?.[0];
        if (file2 && (file2.type.startsWith("image/") || file2.type == "application/pdf") ) {
            fileupload(file2, "driving_licence");
            const imageUrl2 = URL.createObjectURL(file2);
            // formik.setFieldValue("driving_licence", imageUrl2);
        } else {
            toast.error("Please upload a valid image file.");
        }
    };
    const supplierdocument = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file3 = event.target.files?.[0];
        if (file3 && file3.type.startsWith("image/")) {
            fileupload(file3, "statement_by_supplier");
            const imageUrl3 = URL.createObjectURL(file3);
        } else {
            toast.error("Please upload a valid image file.");
        }
    };

    const handleDownload = () => {
        const url = userDetails?.shopperAgreementFileUrl;
        const fileName = `${userDetails?.firstName}_Agreement.pdf`;

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.setAttribute('target', '_blank');
        link.click();
        document.body.removeChild(link);
    };

    const handledeleteaccount = async () => {
        setisdeletempty(false)
        if (deletemsg.trim() !== '') {
            const isDelete = window.confirm("Are you sure you want to delete your account ?")
            if (isDelete) {
                try {
                    const data2 = { rejectReason: deletemsg }
                    const res = await ApiDeleteAccount(`?userId=${userData?.userId}`, data2)
                    toast.success(res.message)
                    if (res.status) {
                        localStorage.clear()
                        navigate('/login')
                    }
                    setisdeleteopen(false)
                } catch (error) {
                    const message =
                        error?.response?.data?.message || // API error message
                        error?.message ||                 // JS error message
                        String(error);
                    toast.error(message)
                }
            }
        }
        else {
            setisdeletempty(true)
        }
    }

    const handleApplyOnline = async () => {
        // localStorage.setItem("tempUserDetails", JSON.stringify(userDetails));
        localStorage.setItem("applyOnlineForm", JSON.stringify(formik.values));
        localStorage.setItem("fa", fulladdress);
        localStorage.setItem("nep", 'true')
        try {
            const data = {
                userId: userDetails?.userId,
                emailId: userDetails?.emailId
            }
            const res = await ApiGetDigisigner(data)
            if (res.status) {
                localStorage.setItem("documentId", (res?.data?.documents[0]?.document_id))
                window.location.href = res?.data?.documents[0]?.signers[0]?.sign_document_url;
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    const handleGetSignedStatement = async () => {
        if (documentId?.length <= 0) return
        try {
            const data = `?documentId=${documentId}&userId=${userData?.userId}`

            const res = await ApiGetSignedStatement(data)
            if (res.status) {
                formik.setFieldValue('statement_by_supplier', res.data)
                formik.setFieldValue('abn', "isProceedWithStatementOfSupplier")
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    useEffect(() => {
        if (documentId?.length > 0) {
            handleGetSignedStatement()
        }
    }, [])

    const isPDF = (url: string) => {
        return url?.toLowerCase().endsWith(".pdf");
    };

    return (
        <>
            <Box height="auto" maxHeight='calc(100vh - 70px)' width='100%' sx={{ overflowX: 'hidden' }}>
                {<form onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }} onSubmit={formik.handleSubmit}>

                    {/* ------------------------------------------------------------------------------------ Part-1---------------------------------------------- */}
                    <Box padding="20px">
                        <Box className='d-flex align-items-center justify-content-end mx-3' gap={2}>
                            <Button className="button-primary py-1 px-3" onClick={handleDownload}>Download Agreement</Button>
                            <Button className="button-primary py-1 px-3" onClick={() => setisdeleteopen(true)}>Delete Account</Button>
                        </Box>
                        <Typography className="form-heading">
                            1. Personal Details {formik.values.firstname}
                        </Typography>
                        <Typography className="form-caption">
                            Tell us a little about yourself.
                        </Typography>
                        <Box className="mt-2 d-flex flex-column flex-md-row gap-3">
                            <Box className="w-md-75 w-100">
                                <FormControl className="w-49 me-2">
                                    <TextField
                                        disabled
                                        label={
                                            <span>
                                                First Name{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        }
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        variant="outlined"
                                        placeholder="Enter your first name"
                                        {...formik.getFieldProps("firstname")}
                                    ></TextField>
                                    {showerror && formik.errors.firstname ? (
                                        <Typography className="error ">
                                            {formik.errors.firstname}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                <FormControl className="w-49">
                                    <TextField
                                        disabled
                                        label={
                                            <span>
                                                Last Name{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        }
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        placeholder="Enter your last name"
                                        {...formik.getFieldProps("lastname")}
                                    ></TextField>
                                    {showerror && formik.errors.lastname ? (
                                        <Typography className="error ">
                                            {formik.errors.lastname}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                <FormControl className="w-49 me-2">
                                    <TextField
                                        label={
                                            <span>
                                                Email{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        }
                                        disabled
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        {...formik.getFieldProps("email")}
                                    ></TextField>
                                    {showerror && formik.errors.email ? (
                                        <Typography className="error ">
                                            {formik.errors.email}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                <FormControl className="w-49">
                                    <TextField
                                        type="number"
                                        placeholder="Enter your mobile number"
                                        label={
                                            <span>
                                                Mobile{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" className="h-100">
                                                    <Typography className="fw-bold">+61</Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        inputProps={{
                                            maxLength: 10,
                                            pattern: "[0-9]*",
                                        }}
                                        value={formik.values.contactNo?.replace(/\s+/g, "")}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            if (value.length <= 10) {
                                                formik.setFieldValue("contactNo", value);
                                            }
                                        }}
                                    ></TextField>
                                    {/* <div className="mt-3">
                                        <label style={{ fontSize: "14px", color: "#0000008A" }} htmlFor="">
                                            <span>
                                                Mobile{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        </label>


                                        <PhoneInput
                                            country={"au"}
                                            
                                            value={formik.values.contactNo} 
                                            onChange={(phone, country: any) => {
                                                let onlyNumber = phone.startsWith(country.dialCode)
                                                    ? phone.slice(country.dialCode.length)
                                                    : phone;
                                                    console.log("Only Number")

                                                formik.setFieldValue("contactNo",onlyNumber);
                                                formik.setFieldValue("countryCode", country.dialCode);
                                            }} inputProps={{
                                                name: "contactNo",
                                                required: true,
                                                autoFocus: false,
                                            }}
                                        />
                                        {showerror && formik.errors.contactNo ? (
                                            <p className="error">{formik.errors.contactNo}</p>
                                        ) : null}
                                    </div> */}
                                    {showerror && formik.errors.contactNo ? (
                                        <Typography className="error ">
                                            {formik.errors.contactNo}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                <FormControl className="w-100 me-2" sx={{ maxWidth: '81%' }}>
                                    <TextField
                                        placeholder="Enter your address"
                                        inputRef={inputRef}
                                        value={fulladdress}
                                        onChange={(e) =>
                                            setfulladdress(e.target.value)
                                        }
                                        label={
                                            <span>
                                                Address{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>

                                        }
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                    // {...formik.getFieldProps("address")}
                                    ></TextField>
                                    {localStorage.getItem('i-x-s') && (<Typography>{userDetails?.address} {userDetails?.city} {userDetails?.state} {userDetails?.userDetails?.postalCode} {userDetails?.country}</Typography>)}
                                    {showerror && formik.errors.address ? (
                                        <Typography className="error ">
                                            {formik.errors.address}
                                        </Typography>
                                    ) : null}
                                    <Typography variant="subtitle2" className="text-secondary"><b>Note:</b> Start typing your address and select it from the suggestions.</Typography>
                                </FormControl>
                                <FormControl className="w-49 me-5">
                                    {/* <TextField
                                    label={
                                        <span>
                                            D.O.B{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }
                                    sx={{


                                    }}

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    {...formik.getFieldProps("dob")}

                                    
                                ></TextField> */}
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={["DatePicker"]}>
                                            <DatePicker
                                                className="w-100"
                                                format="DD-MM-YYYY"
                                                disabled
                                                label={
                                                    <span>
                                                        D.O.B{" "}
                                                        <sup>
                                                            <i className="fa-solid fa-star-of-life star"></i>
                                                        </sup>
                                                    </span>
                                                }
                                                value={
                                                    formik.values.dob ? dayjs(formik.values.dob) : null
                                                } // Ensure it's a dayjs object
                                                minDate={dayjs().subtract(90, 'year')}
                                                maxDate={dayjs().subtract(14, 'year')}
                                                onChange={(newValue) =>
                                                    formik.setFieldValue("dob", dayjs(newValue).format("YYYY-MM-DD"))
                                                }
                                                renderInput={(params) => <TextField {...params} />}
                                                slotProps={{
                                                    textField: {
                                                        InputLabelProps: { shrink: false }, // Prevents label from shrinking
                                                    },
                                                }}
                                                placeholder="Select your date of birth"
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                    {showerror && formik.errors.dob ? (
                                        <Typography className="error ">
                                            {formik.errors.dob}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                <FormControl className="mt-3">
                                    <FormLabel id="demo-row-radio-buttons-group-label">
                                        Gender{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </FormLabel>
                                    <RadioGroup

                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        // name="row-radio-buttons-group"


                                        {...formik.getFieldProps("gender")}
                                    >
                                        <FormControlLabel
                                            value="Male"
                                            control={<BpRadio />}
                                            label="Male"
                                            disabled
                                        />
                                        <FormControlLabel
                                            value="Female"
                                            control={<BpRadio />}
                                            label="Female"
                                            disabled
                                        />
                                    </RadioGroup>
                                    {showerror && formik.errors.gender ? (
                                        <Typography className="error ">
                                            {formik.errors.gender}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                            </Box>
                            <Divider
                                orientation="vertical"
                                sx={{
                                    borderColor: "#00000033",
                                    border: "1px solid #00000033",
                                    height: "auto",
                                }}
                            />
                            <Box className="w-md-25 w-100 d-flex align-items-center justify-content-md-start">
                                <Box width={{ xs: "100%", md: "20%" }}>
                                    <FormControl className="w-100">
                                        {!formik.values.profile_pic && (
                                            <label htmlFor="file-upload" className="form-caption">
                                                <span>
                                                    Profile Image{" "}
                                                    <sup>
                                                        <i className="fa-solid fa-star-of-life star"></i>
                                                    </sup>
                                                </span>

                                                <Box
                                                    className="mt-2 d-flex align-items-center justify-content-center"
                                                    height={300}
                                                    width={{ xs: "100%", md: "300px !important" }}
                                                    border="1px dashed #00000033"
                                                    borderRadius={5}
                                                >
                                                    <input
                                                        type="file"
                                                        id="file-upload"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        onChange={handleFileChange}
                                                    />
                                                    <Box className="d-flex flex-column align-items-center justify-content-center">
                                                        <Box
                                                            component="img"
                                                            height={36}
                                                            width={36}
                                                            src={upload}
                                                        ></Box>
                                                        <Typography className="form-caption">
                                                            Upload Here
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </label>
                                        )}

                                        {formik.values.profile_pic && (
                                            <label htmlFor="file-upload" className="form-caption">
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    height={300}
                                                    width={{ xs: "100%", md: "300px !important" }}
                                                    border="1px dashed #00000033"
                                                    borderRadius={5}
                                                >
                                                    <img
                                                        src={formik.values.profile_pic}
                                                        alt="Uploaded preview"
                                                        width="100%"
                                                        height="100%"

                                                        style={{ borderRadius: "8px", objectFit: 'contain', }}
                                                    />
                                                    <input
                                                        type="file"
                                                        id="file-upload"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        onChange={handleFileChange}
                                                    />
                                                </Box>
                                            </label>
                                        )}
                                        {showerror && formik.errors.profile_pic ? (
                                            <Typography className="error ">
                                                {formik.errors.profile_pic}
                                            </Typography>
                                        ) : null}
                                    </FormControl>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Divider
                        orientation="horizontal"
                        sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
                    />

                    {/* ------------------------------------------------------------------------------------ Part-2---------------------------------------------- */}
                    <Box padding="20px">
                        <Typography className="form-heading">2. Other Details</Typography>
                        <Typography className="form-caption">
                            {" "}
                            these details help us match you to the right tasks{" "}
                        </Typography>
                        <Box>
                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Do you or an immediate family member or close friend work for
                                    ALDI?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("workForAldi")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.workForAldi ? (
                                    <Typography className="error ">
                                        {formik.errors.workForAldi}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className="mt-3 col-md-4 col-12">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Do you or an immediate family member or close friend work for
                                    Blooms the Chemist?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("workForBlooms")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="No"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.workForBlooms ? (
                                    <Typography className="error ">
                                        {formik.errors.workForBlooms}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className="mt-3 col-md-4 col-12">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Do you or an immediate family member or close friend work for
                                    a hotel/pub chain?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    // row
                                    // aria-labelledby="hotel-pub-radio-label"
                                    // name="workForHotelpub"
                                    // value={formik.values.workForHotelpub}
                                    // onChange={(e) => {
                                    //   const value = e.target.value === "true";
                                    //   formik.setFieldValue("workForHotelpub", value);
                                    //   if (!value) {
                                    //     formik.setFieldValue("hotelPubName", "");
                                    //   }
                                    // }}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("workForHotelpub")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="No"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.workForHotelpub ? (
                                    <Typography className="error ">
                                        {formik.errors.workForHotelpub}
                                    </Typography>
                                ) : null}
                            </FormControl>

                            {formik.values.workForHotelpub === "true" && (
                                <FormControl className="col-md-4 col-12">
                                    <TextField
                                        placeholder="Enter the name of the hotel/pub"
                                        label={
                                            <span>
                                                Hotel/Pub Name{" "}
                                                <sup>
                                                    <i className="fa-solid fa-star-of-life star"></i>
                                                </sup>
                                            </span>
                                        }
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                        {...formik.getFieldProps("hotelPubName")}
                                    />
                                    {showerror && formik.errors.hotelPubName ? (
                                        <Typography className="error ">
                                            {formik.errors.hotelPubName}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                            )}

                        </Box>
                        <Box>
                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Are you prepared to buy alcohol?*{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("buyAlcohol")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.buyAlcohol ? (
                                    <Typography className="error ">
                                        {formik.errors.buyAlcohol}
                                    </Typography>
                                ) : null}
                            </FormControl>

                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Are you prepared to go into the smoking area?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("isShopperCanVisitSmokingArea")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.isShopperCanVisitSmokingArea ? (
                                    <Typography className="error ">
                                        {formik.errors.isShopperCanVisitSmokingArea}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Are you prepared to gamble?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("isShopperCanDoGambling")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.isShopperCanDoGambling ? (
                                    <Typography className="error ">
                                        {formik.errors.isShopperCanDoGambling}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Do you or an immediate family member or close friend work for Yo-Chi?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("isShopperRelativeWorkForYochi")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.isShopperRelativeWorkForYochi ? (
                                    <Typography className="error ">
                                        {formik.errors.isShopperRelativeWorkForYochi}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className="col-md-4 col-12 mt-3">
                                <FormLabel id="demo-row-radio-buttons-group-label">
                                    Do you or an immediate family member or close friend work for JB Hi-Fi or Good Guys?{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    // name="row-radio-buttons-group"
                                    {...formik.getFieldProps("isShopperRelativeWorkForJbHifi")}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<BpRadio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<BpRadio />}
                                        label="NO"
                                    />
                                </RadioGroup>
                                {showerror && formik.errors.isShopperRelativeWorkForJbHifi ? (
                                    <Typography className="error ">
                                        {formik.errors.isShopperRelativeWorkForJbHifi}
                                    </Typography>
                                ) : null}
                            </FormControl>
                        </Box>
                    </Box>
                    <Divider
                        orientation="horizontal"
                        sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
                    />

                    {/* ---------------------------------------------------------------------------------Part-3 -------------------------------------------------------------- */}
                    <Box padding="20px">
                        <Typography className="form-heading">
                            3. Identification
                        </Typography>
                        <Typography className="form-caption">
                            Upload documents for verification.
                        </Typography>
                        <Box
                            width={{ xs: "100%", md: "20%" }}
                            className="mt-2 d-flex align-items-center"
                        >
                            <FormControl className="w-100">
                                {!formik.values.driving_licence && (
                                    <label htmlFor="file-upload2" className="form-caption ">
                                        <span>
                                            Add your Driver's License or Photo ID here{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>

                                        <Box
                                            className="mt-2 d-flex align-items-center justify-content-center "
                                            height={180}
                                            width={{ xs: "100%", md: "300px !important" }}
                                            border="1px dashed #00000033"
                                            borderRadius={5}
                                        >
                                            <input
                                                // disabled
                                                type="file"
                                                id="file-upload2"
                                                accept="image/*,.pdf"
                                                style={{ display: "none" }}
                                                onChange={handleFileChange2}
                                            />
                                            <Box className="d-flex flex-column align-items-center justify-content-center">
                                                <Box
                                                    component="img"
                                                    height={36}
                                                    width={36}
                                                    src={gallery}
                                                ></Box>
                                                <Typography className="form-caption">
                                                    Capture/Upload Here
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </label>
                                )}

                                {formik.values.driving_licence && (
                                    <>
                                        <Box className='d-flex justify-content-end'>
                                            <IconButton onClick={() => { formik.setFieldValue('driving_licence', null) }}><CancelOutlined /></IconButton>
                                        </Box>
                                        {isPDF(formik.values.driving_licence) ? (
                                            <iframe
                                                src={`${formik.values.driving_licence}#toolbar=0`}
                                                title="PDF Preview"
                                                width="100%"
                                                height="400px"
                                                style={{ border: "none", borderRadius: "8px" }}
                                            />
                                        ) : (
                                            <img
                                                src={formik.values.driving_licence}
                                                alt="Uploaded preview"
                                                width="100%"
                                                height="100%"
                                                style={{ objectFit: "cover", border:'2px dashed #ccc', borderRadius: "8px" }}
                                            />
                                        )}
                                    </>
                                )}
                                {showerror && formik.errors.driving_licence ? (
                                    <Typography className="error ">
                                        {formik.errors.driving_licence}
                                    </Typography>
                                ) : null}
                            </FormControl>
                        </Box>
                    </Box>
                    <Divider
                        orientation="horizontal"
                        sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
                    />

                    {/* ---------------------------------------------------------------------------------Part-4 -------------------------------------------------------------- */}
                    {/* <Box padding="20px">
                        <Typography className="form-heading">
                            4. Shopper Application
                        </Typography>
                        <Typography className="form-caption">
                            Final step! Submit your application
                        </Typography>
                        <FormControl className="w-100 mt-2">
                            <label htmlFor="textarea-label" className="form-caption">
                                <span>
                                    Please write a 150–500-character review of a recent customer
                                    service experience you have had at a store, restaurant or
                                    hotel. This should be fact-based{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </label>
                            <textarea
                                disabled
                                id="textarea-label"
                                className="custom-textarea"
                                placeholder="Enter your review here"
                                rows={4}
                                value={formik.values.shoppperDetail}
                                onChange={(e) => {
                                    const text = e.target.value;
                                    const wordCount = text
                                        .trim()
                                        .split(/\s+/)
                                        .filter(Boolean).length;
                                    if (wordCount <= 500) {
                                        formik.setFieldValue("shoppperDetail", text);
                                    }
                                }}
                            />
                            <Typography
                                className="letter-count text-secondary"
                                variant="caption"
                                position="absolute"
                                bottom={20}
                                right={10}
                            >
                                Words:{" "}
                                {
                                    formik.values.shoppperDetail
                                        .trim()
                                        .split(/\s+/)
                                        .filter(Boolean).length
                                }
                            </Typography>
                            {showerror && formik.errors.shoppperDetail ? (
                                <Typography className="error ">
                                    {formik.errors.shoppperDetail}
                                </Typography>
                            ) : null}
                        </FormControl>
                    </Box> */}
                    <Divider
                        className="mb-3"
                        orientation="horizontal"
                        sx={{ borderColor: "#00000033", border: "1px solid #00000033" }}
                    />
                    {/* ------------------------------------------------------------------------------------ Part-5---------------------------------------------- */}
                    <Box padding='20px'>

                        <Typography className='form-heading'>4. Bank Details</Typography>
                        <Typography className='form-caption'>Share your Bank Details for the Payments.</Typography>
                        <Box className='mt-2 w-100 d-flex flex-column flex-md-row gap-2'>
                            <FormControl className='col-md-4 col-12'>
                                <TextField
                                    label={
                                        <span>
                                            Bank Name{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    {...formik.getFieldProps("bankName")}
                                ></TextField>
                                {showerror && formik.errors.bankName ? (
                                    <Typography className="error ">
                                        {formik.errors.bankName}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className='col-md-4 col-12'>
                                <TextField
                                    label={
                                        <span>
                                            BSB{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }
                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    // inputProps={{
                                    //     maxLength: 6
                                    // }}
                                    {...formik.getFieldProps("bic")}
                                ></TextField>
                                {showerror && formik.errors.bic ? (
                                    <Typography className="error ">
                                        {formik.errors.bic}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className='flex-grow-1'>
                                <TextField
                                    label={
                                        <span>
                                            Account No.{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }

                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    // inputProps={{
                                    //     maxLength: 10
                                    // }}
                                    {...formik.getFieldProps("accountNo")}
                                ></TextField>
                                {showerror && formik.errors.accountNo ? (
                                    <Typography className="error ">
                                        {formik.errors.accountNo}
                                    </Typography>
                                ) : null}
                            </FormControl>

                        </Box>
                    </Box>

                    <Divider orientation='horizontal' sx={{ borderColor: '#00000033', border: '1px solid #00000033' }} />

                    {/* ------------------------------------------------------------------------------------ Part-6---------------------------------------------- */}
                    <Box padding='20px'>

                        <Typography className='form-heading'>5. Tax Details</Typography>
                        <Typography className='form-caption'>To become a mystery shopper, you need to provide an ABN or Statement of Supplier</Typography>
                        <Box className='mt-2 w-100 d-flex flex-column flex-md-row gap-2'>
                            <Box className='col-md-4 col-12'>
                                <FormControl className='mt-3'>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Do you want to proceed with Statement by a Supplier or ABN?{" "}   <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup></FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        // name="row-radio-buttons-group"
                                        {...formik.getFieldProps("abn")}
                                    >
                                        <FormControlLabel value="isProceedWithStatementOfSupplier" control={<BpRadio />}
                                            label={
                                                <>
                                                    Statement by a Supplier
                                                    <Tooltip className='ms-2' title="Please note that we are not a registered tax agent and are unable to provide advice regarding ABNs or Statement by a Supplier. We recommend speaking directly with the ATO or a licensed tax professional for guidance." arrow>
                                                        <Box component='img' className='col-1' src={info}></Box>
                                                    </Tooltip>
                                                </>} />
                                        <FormControlLabel value="isProceedWithABN" control={<BpRadio />} label="ABN" />
                                    </RadioGroup>
                                    {showerror && formik.errors.abn ? (
                                        <Typography className="error ">
                                            {formik.errors.abn}
                                        </Typography>
                                    ) : null}
                                </FormControl>
                                {formik.values?.abn === 'isProceedWithStatementOfSupplier' && (
                                    <>
                                        <Typography className='form-caption'>
                                            {/* Statement of Supplier form with information on how to fill this out or ABN Number{' '} */}
                                            {/* <i className="fa-solid fa-star-of-life star"></i> */}
                                        </Typography>

                                        {!formik.values.statement_by_supplier || (isCreate) ? (
                                            <Button
                                                variant='outlined'
                                                className='button-primary-outlined py-2 px-120 mt-2'
                                                onClick={() => { handleApplyOnline() }}
                                            >
                                                OPEN STATEMENT BY SUPPLY FORM
                                            </Button>
                                        ) : (
                                            <Box className='d-flex align-items-center gap-3'>
                                                <Link
                                                    target='_blank'
                                                    className='custom-text'
                                                    to={formik.values.statement_by_supplier}
                                                >
                                                    <Button
                                                        variant='outlined'
                                                        className='button-primary-outlined py-2 px-120 mt-2'
                                                    >
                                                        Download Statement
                                                    </Button>
                                                </Link>
                                            </Box>
                                        )}
                                    </>
                                )}
                            </Box>
                            {formik.values?.abn === 'isProceedWithStatementOfSupplier' && <> <Divider orientation='vertical' sx={{ borderColor: '#00000033', height: 'auto' }} />
                                <Box className='col-md-4 col-12'>
                                    <Box className='w-100 d-flex align-items-center ms-2'>
                                        <FormControl>
                                            {!formik.values.statement_by_supplier && !documentId && <label htmlFor="file-upload3" className='form-caption'>
                                                <span>
                                                    Upload Statement by a Supplier{" "}
                                                    <sup>
                                                        <i className="fa-solid fa-star-of-life star"></i>
                                                    </sup>
                                                </span>

                                                <Box className='mt-2 d-flex align-items-center justify-content-center' height={150} width={335} border='1px dashed #00000033' borderRadius={5}>
                                                    <input
                                                        type="file"
                                                        id="file-upload3"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        onChange={(e) => { supplierdocument(e) }}
                                                    />
                                                    <Box className='d-flex flex-column align-items-center justify-content-center'>
                                                        <Box component='img' height={36} width={36} src={upload}></Box>
                                                        <Typography className='form-caption'>Upload Here</Typography>
                                                    </Box>
                                                </Box>
                                            </label>
                                            }

                                            {(formik.values.statement_by_supplier || documentId) &&
                                                <>
                                                    <Box className='d-flex justify-content-end'>
                                                        <IconButton onClick={() => { formik.setFieldValue('statement_by_supplier', null) }}><CancelOutlined /></IconButton>
                                                    </Box>
                                                    {isPDF(formik.values.statement_by_supplier) ? (
                                                        <iframe
                                                            src={`${formik.values.statement_by_supplier}#toolbar=0`}
                                                            title="PDF Preview"
                                                            width="100%"
                                                            height="421px"
                                                            style={{ border: "none", borderRadius: "8px" }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={formik.values.statement_by_supplier}
                                                            alt="Uploaded preview"
                                                            width="100%"
                                                            height="100%"
                                                            style={{ objectFit: "cover", borderRadius: "8px" }}
                                                        />
                                                    )}
                                                </>
                                            }

                                        </FormControl>

                                    </Box>
                                </Box>
                            </>
                            }

                        </Box>
                        {formik.values?.abn === 'isProceedWithABN' && <FormControl className='col-md-4 col-12'>
                            <TextField
                                label={
                                    <span>
                                        ABN{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                InputLabelProps={{
                                    shrink: false,

                                }}
                                inputProps={{
                                    maxLength: 11
                                }}

                                {...formik.getFieldProps("ABNNumber")}
                            ></TextField>

                            {showerror && formik.errors.ABNNumber ? (
                                <Typography className="error ">
                                    {formik.errors.ABNNumber}
                                </Typography>
                            ) : null}
                        </FormControl>}
                    </Box>


                    <Box className="w-100 d-flex justify-content-end p-2 pe-3">
                        <Button
                            type="submit"
                            onClick={() => {
                                setshowerror(true);
                                // formik.handleSubmit()
                            }}
                            className="button-primary w-30 py-2 px-70"
                        >
                            Submit
                        </Button>
                    </Box>
                </form>
                }

                <Dialog open={isdeleteopen} onClose={() => setisdeleteopen(false)}>
                    <div className="p-3 pb-0 mb-0 ms-auto">
                        <IconButton onClick={() => { setisdeleteopen(false); setdeletemsg(""); }}>
                            <CancelOutlined />
                        </IconButton>
                    </div>
                    <DialogContent className="px-5">
                        <h1 className="text-center"> Delete Account</h1>
                        <FormControl className="w-100">
                            <TextField
                                label={
                                    <span>
                                        Please tell us why you want to delete your account.&nbsp;
                                        {/* <span style={{
                                            userSelect: 'none',
                                            WebkitUserSelect: 'none',
                                            MozUserSelect: 'none',
                                            msUserSelect: 'none',
                                            fontWeight: 'bold'
                                        }} onCopy={(e) => { e.preventDefault() }}>Delete</span> */}

                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                value={deletemsg}
                                onChange={(e) => { setisdeletempty(false); setdeletemsg(e.target.value) }}
                                InputLabelProps={{
                                    shrink: false,
                                }}
                            ></TextField>
                            {isdeletempty && <Typography className="text-danger" variant="caption">please write Delete</Typography>}
                        </FormControl>
                        <Box className='d-flex align-items-center justify-content-center mt-5'>
                            <Button className="button-primary py-1 px-3" onClick={handledeleteaccount}>Delete my Account</Button>
                        </Box>
                    </DialogContent>
                </Dialog>
                {loading && <Loading />}
            </Box>


        </>
    );
}

export default Profile;
